import { lazy } from 'react'

const GiftCode = lazy(() => import('../../views/pages/event/giftcode'))
const Award = lazy(() => import('../../views/pages/event/award'))
const Charge = lazy(() => import('../../views/pages/event/charge'))
const Top = lazy(() => import('../../views/pages/event/top'))
const Goblin = lazy(() => import('../../views/pages/event/goblin'))

const MoneyRoutes = [
	{
		path: '/event/giftcode',
		element: <GiftCode />,
		meta: {
			publicRoute: false
		}
	},
	{
		path: '/event/award',
		element: <Award />,
		meta: {
			publicRoute: false,
			className: 'ecommerce-application'
		}
	},
	{
		path: '/event/charge',
		element: <Charge />,
		meta: {
			publicRoute: false,
			className: 'ecommerce-application'
		}
	},
	{
		path: '/event/top',
		element: <Top />,
		meta: {
			publicRoute: false
		}
	},
	{
		path: '/event/goblin',
		element: <Goblin />,
		meta: {
			publicRoute: false
		}
	}
]

export default MoneyRoutes
